import {Subscription} from 'rxjs';
import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatSlider, MatSliderThumb} from '@angular/material/slider';
import {DashboardStudyViewerControllerService} from '../../../dashboard-study/services/dashboard-study-viewer-controller/dashboard-study-viewer-controller.service';

@Component({
  selector: 'app-dashboard-study-viewer-zoomed-controls-opacity',
  templateUrl: './dashboard-study-viewer-zoomed-controls-opacity.component.html',
  styleUrls: ['./dashboard-study-viewer-zoomed-controls-opacity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, MatSlider, MatSliderThumb],
})
export class DashboardStudyViewerZoomedControlsOpacityComponent implements OnInit, OnDestroy {
  /** Currently focused view region in the study viewer. */
  public readonly renderedViewRegion = this.studyViewerController.renderedViewRegion;

  /** Default opacity for the label scan images. */
  public readonly defaultLabelScanImagesOpacity = 100;

  /** Opacity control for the label scan image. */
  public readonly opacityControl = new FormControl<number>(this.defaultLabelScanImagesOpacity);

  /** Component subscriptions. Will be unsubscribed on component destroy. */
  public readonly subscription = new Subscription();

  constructor(private studyViewerController: DashboardStudyViewerControllerService) {}

  ngOnInit(): void {
    this.subscription.add(this.opacityControl.valueChanges.subscribe(opacity => this.updateFocusedViewRegionOpacity(opacity)));
  }

  /**
   * Updates the opacity of the label images for the focused view region.
   * @param opacity - The opacity value to set for the label scan images (0-100).
   */
  public updateFocusedViewRegionOpacity(opacity: number): void {
    this.studyViewerController.setOpacityForFocusedViewRegion(opacity / 100);
  }

  /**
   * Resets the opacity of the label scan images for the focused view region to the default value.
   */
  public resetFocusedViewRegionOpacity(): void {
    this.studyViewerController.setParamsForLabeledScans(this.renderedViewRegion());
    this.studyViewerController.papayaController.redrawPapayaViewer();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();

    // Reset opacity to default value when the zoomed in view is closed.
    this.resetFocusedViewRegionOpacity();
  }
}
